import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { visibility, flyInOut, expand } from "../animations/app.animation";
import { Dish } from "../shared/dish";
import { Comment } from "../shared/comment";
import { DishService } from "../services/dish.service";
import { FavoriteService } from "../services/favorite.service";

import { Params, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";

import { switchMap } from "rxjs/operators";

@Component({
  selector: "app-dishdetail",
  templateUrl: "./dishdetail.component.html",
  styleUrls: ["./dishdetail.component.scss"],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    "[@flyInOut]": "true",
    style: "display: block;",
  },
  animations: [visibility(), flyInOut(), expand()],
})
export class DishdetailComponent implements OnInit {
  @ViewChild("cform") commentFormDirective;
  dish: Dish;
  dishcopy: Dish;
  dishIds: string[];
  prev: string;
  next: string;
  comment: Comment;
  errMess: string;
  visibility = "shown";
  favorite = false;

  formErrors = {
    comment: "",
  };

  validationMessages = {
    comment: {
      required: "Comment is required.",
    },
  };

  commentForm: FormGroup;

  constructor(
    private dishservice: DishService,
    private favoriteService: FavoriteService,
    private route: ActivatedRoute,
    private location: Location,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();

    this.dishservice
      .getDishIds()
      .subscribe((dishIds) => (this.dishIds = dishIds));
    this.route.params
      .pipe(
        switchMap((params: Params) => {
          this.visibility = "hidden";
          return this.dishservice.getDish(params["id"]);
        })
      )
      .subscribe(
        (dish) => {
          this.dish = dish;
          this.dishservice
            .getComments(this.dish._id)
            .subscribe((comments) => (this.dish.comments = comments));
          this.setPrevNext(dish._id);
          this.visibility = "shown";
          this.favoriteService.isFavorite(this.dish._id).then((value) => {
            this.favorite = value;
            console.log("Dishdetail favorite ", this.favorite);
          });
        },
        (errmess) => (this.errMess = <any>errmess)
      );
  }

  setPrevNext(dishId: string) {
    const index = this.dishIds.indexOf(dishId);
    this.prev = this.dishIds[
      (this.dishIds.length + index - 1) % this.dishIds.length
    ];
    this.next = this.dishIds[
      (this.dishIds.length + index + 1) % this.dishIds.length
    ];
  }

  goBack(): void {
    this.location.back();
  }

  createForm() {
    this.commentForm = this.fb.group({
      rating: 5,
      comment: ["", Validators.required],
    });

    this.commentForm.valueChanges.subscribe((data) =>
      this.onValueChanged(data)
    );

    this.onValueChanged(); // (re)set validation messages now
  }

  onSubmit() {
    this.dishservice.postComment(this.dish._id, this.commentForm.value).then(
      () => {
        this.dishservice
          .getComments(this.dish._id)
          .subscribe((comments) => (this.dish.comments = comments));
      },
      (err) => console.log("Error ", err)
    );
    this.commentFormDirective.resetForm();
    this.commentForm.reset({
      rating: 5,
      comment: "",
    });
  }

  onValueChanged(data?: any) {
    if (!this.commentForm) {
      return;
    }
    const form = this.commentForm;
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = "";
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + " ";
            }
          }
        }
      }
    }
  }

  addToFavorites() {
    if (!this.favorite) {
      this.favoriteService
        .postFavorite(this.dish._id)
        .then((favorites) => {
          console.log(favorites);
          this.favorite = true;
        })
        .catch((err) => console.log("Error ", err));
    }
  }
}
